import {BaseContainerModel} from '../../base-container.model';
import {
  bl_aat_claim_account_entitlement_auto_top_up_template_RowClass,
} from '../../../dbschema';

export class ClaimEntitlementAutoTopUpContainerModel extends BaseContainerModel {
  bl_aat_claim_account_entitlement_auto_top_up_template: bl_aat_claim_account_entitlement_auto_top_up_template_RowClass =
    new bl_aat_claim_account_entitlement_auto_top_up_template_RowClass();
}
